import React, { Component  } from 'react';
import { Route } from 'react-router';
//import { Layout } from './components/Layout';
//import { Home } from './components/Home';
//import { FetchData } from './components/FetchData';
//import { Counter } from './components/Counter';
// import { Layout } from './components/Map/Layout';
import { System } from './components/System';

import './custom.css'
export default class App extends Component {
    static displayName = App.name;

    render () {
        return (            
            <div>
                <Route exact path='/' component={System} />
                {/* <Route exact path='/' component={Layout} /> */}
                {/*<Route exact path='/' component={Home} />*/}
                {/*<Route path='/map' component={Map} />*/}
                {/*<Route path='/counter' component={Counter} />*/}
                {/*<Route path='/fetch-data' component={FetchData} />*/}
            </div>
        );
    }
}